"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button"));

var _ButtonDropDown = _interopRequireDefault(require("../ButtonDropDown"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var warnNotButton = function warnNotButton(component) {
  // eslint-disable-next-line no-console
  console.error("ButtonGroup only supports buttons nested directly within or one level below the ButtonGroup. This ButtonGroup contains an item that doesn't meet this criteria.");
  return component;
};

var ButtonGroup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ButtonGroup, _Component);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup() {
    var _this;

    (0, _classCallCheck2.default)(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _classNames, _classNames2;

      var _this$props = _this.props,
          id = _this$props.id,
          layout = _this$props.layout,
          classes = _this$props.classes,
          className = _this$props.className,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["id", "layout", "classes", "className"]);
      var buttonClassNames = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.alignLeft, layout === "left"), (0, _defineProperty2.default)(_classNames, classes.alignRight, layout === "right"), (0, _defineProperty2.default)(_classNames, classes.splitButton, layout === "justify" || layout === "justified"), (0, _defineProperty2.default)(_classNames, classes.alignCenter, layout === "center"), (0, _defineProperty2.default)(_classNames, classes.stackedButton, layout === "stacked"), _classNames));
      var children = Array.isArray(_this.props.children) ? _this.props.children.filter(function (c) {
        return c;
      }) : _this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        id: id
      }, otherProps, {
        className: (0, _classnames.default)("prmbl-buttonGroup", className, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.rightButtons, layout === "right"), (0, _defineProperty2.default)(_classNames2, classes.justifiedButtons, layout === "justify" || layout === "justified"), (0, _defineProperty2.default)(_classNames2, classes.centerButtons, layout === "center"), _classNames2))
      }), _react.default.Children.map(children, function (Child) {
        return (// If the child is a button, apply classname to the child
          Child.type === _Button.default || Child.type === _ButtonDropDown.default ? /*#__PURE__*/_react.default.cloneElement(Child, {
            className: (0, _classnames.default)(Child.props.className, buttonClassNames)
          }) : // If the child contains a button one level deep, apply classnames to that button
          Child.props.children.type === _Button.default || Child.props.children.type === _ButtonDropDown.default ? /*#__PURE__*/_react.default.cloneElement(Child, {
            children: /*#__PURE__*/_react.default.cloneElement(Child.props.children, {
              className: (0, _classnames.default)(Child.props.children.props.className, buttonClassNames)
            })
          }) : // Doesn't appear to be a button, don't apply classnames
          warnNotButton(Child)
        );
      }));
    });
    return _this;
  }

  return ButtonGroup;
}(_react.Component);

(0, _defineProperty2.default)(ButtonGroup, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   *
   * Needed to remove warning on compile.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),

  /**
   * Sets the layout and margin of your group of buttons
   */
  layout: _propTypes.default.oneOf(["left", "right", "justify", "stacked", "center"]),

  /**
   * Classes to apply to the root
   */
  className: _propTypes.default.string
});
(0, _defineProperty2.default)(ButtonGroup, "defaultProps", {
  layout: "left"
});
var buttonGroupWithStyles = (0, _styles.withStyles)(_styles2.styles)(ButtonGroup);
exports.Button = buttonGroupWithStyles;
buttonGroupWithStyles.defaultProps = {
  layout: "left"
};

// Export styled version with name "ButtonGroup"
var _default = (0, _styles.withStyles)(_styles2.styles)(ButtonGroup); // Keep existing default export working


exports.default = _default;